const Card = ({ title, status, color = "green" }) => {
  return (
    <>
      <div className="overview-card">
        <div className="overview-label">
          <span className={`dot dot-${color} rounded-circle d-inline-block`}></span>
          <span>{title}</span>
        </div>
        <div className="overview-value">{status}</div>
      </div>
    </>
  );
};

export default Card;
